/**
 * Store: Nosto
 * -----------------------------------------------------------------------------
 * Handles Nosto API events and state.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    method: 'viewOther',
    methodParam: false,
    placements: [],
    ready: false,
    recommendations: {},
  }),

  mutations: {

    /**
     * Set method state.
     * @param {String} method - Nosto method type.
     */
    SET_METHOD(state, method) {
      state.method = method
    },

    /**
     * Set method parameter state.
     * @param {String} methodParam - Nosto method parameter.
     */
    SET_METHOD_PARAM(state, methodParam) {
      state.methodParam = methodParam
    },

    /**
     * Set placements state.
     * @param {Array|Boolean} placements - Placement IDs to load, set false to
     * clear placements.
     */
    SET_PLACEMENTS(state, placements) {
      if (placements === false) {
        state.placements = []
        return
      }

      const newPlacements = [
        ...state.placements,
        ...placements,
      ]

      const duplicates = []

      state.placements = newPlacements.filter((placement) => {
        if (duplicates.includes(placement)) {
          return false
        }

        duplicates.push(placement)
        return true
      })
    },

    /**
     * Set Nosto ready state.
     */
    SET_READY(state) {
      state.ready = true
    },

    /**
     * Set recommendations state.
     * @param {Object} recommendations - New recommendations to overwrite with.
     */
    SET_RECOMMENDATIONS(state, recommendations) {
      state.recommendations = {
        ...state.recommendations,
        ...recommendations,
      }
    },
  },

  actions: {

    /**
     * Commit method state.
     * @param {String} method - Nosto method type.
     */
    setMethod({ commit }, method) {
      commit('SET_METHOD', method)
    },

    /**
     * Commit method parameter state.
     * @param {String} methodParam - Nosto method parameter.
     */
    setMethodParam({ commit }, methodParam) {
      commit('SET_METHOD_PARAM', methodParam)
    },

    /**
     * Commit placements state.
     * @param {Array|Boolean} placements - Placement IDs to load, set false to
     * clear placements.
     */
    setPlacements({ commit }, placements) {
      commit('SET_PLACEMENTS', placements)
    },

    /**
     * Commit Nosto ready state.
     */
    setReady({ commit }) {
      commit('SET_READY')
    },

    /**
     * Commit recommendations state.
     * @param {Object} recommendations - New recommendations to overwrite with.
     */
    setRecommendations({ commit }, recommendations) {
      commit('SET_RECOMMENDATIONS', recommendations)
    },
  },
}
